module.exports = __webpack_public_path__ + "static/media/man-road.2938f1df.jpg";